import { List, Create, Edit, View, Barcode } from "../Components/index.js";

export default [
    {
        path: "/canteen/ledger",
        component: List,
        name: "canteen.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/ledger/create",
        component: Create,
        name: "canteen.ledger.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/ledger/:id/edit",
        component: Edit,
        name: "canteen.ledger.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/ledger/:id/view",
        component: View,
        name: "canteen.ledger.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/ledger-barcode",
        component: Barcode,
        name: "canteen.ledger.barcode",
        meta: {
            requiresAuth: true,
        },
    },
];
